import colorsJson from './colors.json'

const { colors, variants } = colorsJson

export { colors, variants }
